/* GS://PROTOCOLO
 * Arquivo: src/components/forms/AdjustPointsForm.js
 * Descrição: Formulário para ajuste manual de pontos via Cloud Function blindada.
 * Versão: 1.1 - Fix: Clean code (No unused vars)
 */

import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { Save, AlertCircle, Loader2, DollarSign } from 'lucide-react';

const AdjustPointsForm = ({ user, onClose, onSuccess }) => {
  const [amount, setAmount] = useState('');
  const [reason, setReason] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setSuccessMsg(null);

    const val = parseInt(amount);
    if (isNaN(val) || val === 0) {
      setError("A quantidade deve ser diferente de zero.");
      setIsLoading(false);
      return;
    }
    if (!reason || reason.trim().length < 3) {
      setError("O motivo é obrigatório (min. 3 letras).");
      setIsLoading(false);
      return;
    }

    try {
      // Conexão com a Cloud Function na região correta
      const functions = getFunctions(undefined, 'southamerica-east1');
      const manualPointAdjustment = httpsCallable(functions, 'manualPointAdjustment');

      const response = await manualPointAdjustment({
        userId: user.uid,
        amount: val,
        reason: reason.trim()
      });

      // [FIX]: Removido 'message' que não estava sendo usado
      const { newBalance } = response.data;
      setSuccessMsg(`Sucesso! Novo saldo: ${newBalance} GP.`);
      
      // Aguarda um pouco para o usuário ler antes de fechar
      setTimeout(() => {
        if (onSuccess) onSuccess();
        if (onClose) onClose();
      }, 2000);

    } catch (err) {
      console.error("Erro no ajuste:", err);
      setError(err.message || "Erro ao processar ajuste.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-4">
      <div className="mb-4 bg-blue-50 text-blue-800 p-3 rounded text-sm flex items-center">
        <DollarSign className="w-4 h-4 mr-2" />
        <span>Carteira: <strong>{user.displayName || user.email}</strong></span>
      </div>

      {error && (
        <div className="mb-4 bg-red-50 text-red-600 p-3 rounded flex items-center">
          <AlertCircle className="w-4 h-4 mr-2" />
          {error}
        </div>
      )}

      {successMsg && (
        <div className="mb-4 bg-green-50 text-green-700 p-3 rounded font-medium text-center">
          {successMsg}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Quantidade de Pontos (+ Crédito / - Débito)
          </label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className="w-full border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-brand-gold focus:border-transparent"
            placeholder="Ex: 50 ou -50"
            disabled={isLoading || successMsg}
          />
          <p className="text-xs text-gray-500 mt-1">Use valores negativos para remover pontos.</p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Motivo (Para Auditoria)
          </label>
          <input
            type="text"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="w-full border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-brand-gold focus:border-transparent"
            placeholder="Ex: Bônus campanha Instagram / Correção erro PDV"
            disabled={isLoading || successMsg}
          />
        </div>

        <div className="flex justify-end gap-3 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
            disabled={isLoading}
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={isLoading || successMsg}
            className="px-4 py-2 bg-brand-gold text-brand-black font-semibold rounded hover:bg-yellow-500 disabled:opacity-50 flex items-center"
          >
            {isLoading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Save className="w-4 h-4 mr-2" />}
            Confirmar Ajuste
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdjustPointsForm;